import WebFont from '@polleverywhere/webfontloader'

const TIMEOUT_REJECTION_TIME = 30000 // 30s

export const FONTS = {
  'Proxima Nova': 'proxima-nova',
  'Tisa Web Pro': 'ff-tisa-web-pro',
  'Netto Web': 'ff-netto-web',
  'Source Sans Pro': 'source-sans-pro',
  'Lucida Grande': 'Lucida Grande',
  Helvetica: 'Helvetica',
  Georgia: 'Georgia',
  // Custom account fonts
  Arial: 'Arial',
  Splunk: 'Splunk',
  Inspira: 'Inspira',
  VW: 'VW',
  'Helvetica Neue': 'HelveticaNeue',
  Metric: 'Metric',
  'MS Gothic': 'MS Gothic',
  'MS UI Gothic': 'MS UI Gothic',
  'MS PGothic': 'MS PGothic',
  'ヒラギノ角ゴ Pro W3': 'ヒラギノ角ゴ Pro W3',
  'Hiragino Kaku Gothic Pro': 'Hiragino Kaku Gothic Pro',
  Osaka: 'Osaka',
  メイリオ: 'メイリオ',
  Meiryo: 'Meiro'
}

export const FALLBACK_FONT_ORDER = [
  'source-sans-pro',
  "'Lucida Grande'",
  'Calibri',
  'Verdana',
  'Helvetica',
  'Arial',
  'sans-serif'
]

export function initializeTypekit (typekitId) {
  return new Promise((resolve, reject) => {
    WebFont.load({
      typekit: { id: typekitId },
      active: resolve,
      inactive: function () {
        reject(new Error('Custom fonts failed to render.'))
      },
      timeout: TIMEOUT_REJECTION_TIME
    })
  })
}

export function applyFont (element, font) {
  return new Promise((resolve, reject) => {
    if ([...Object.values(FONTS)].includes(font)) {
      const fontFamily = [font, ...FALLBACK_FONT_ORDER]
      const fontIndex = FALLBACK_FONT_ORDER.indexOf(font)

      ;(fontIndex > -1) && fontFamily.splice(fontIndex + 1, 1)

      element.style.fontFamily = fontFamily.join(', ')
      resolve()
    } else {
      element.style.fontFamily = FALLBACK_FONT_ORDER.join(', ')
      if (font) {
        reject(new Error(`Invalid font: ${font}`))
      } else {
        resolve()
      }
    }
  })
}
